var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "base-dropdown",
    class: {
      collapsed: _vm.collapsed
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focusout": _vm.handleFocusOut
    }
  }, [_c('div', {
    staticClass: "dropdown-container"
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": _vm.onDropDownClick
    }
  }, [_c('div', {
    staticClass: "left",
    class: _vm.showIcon ? _vm.isCorrect ? 'correct' : 'wrong' : _vm.isCorrect ? 'correct-disabled' : ''
  }, [_vm.showIcon ? _c('div', {
    staticClass: "feedback-icon-section"
  }, [_c('span', [_vm._v(" ")]), !_vm.isCorrect ? _c('WrongIcon', {
    staticClass: "feedbackIcon",
    attrs: {
      "iconColor": "#FFFFFF"
    }
  }) : _vm.isCorrect ? _c('CorrectIcon', {
    staticClass: "feedbackIcon",
    attrs: {
      "iconColor": "#FFFFFF"
    }
  }) : _vm._e(), _c('span', [_vm._v(" ")])], 1) : _vm.selection ? _c('span', [_vm._v(_vm._s(_vm.selection.value))]) : _c('span', [_vm._v(" ")]), _c('div', {
    staticClass: "hidden-option-spacer"
  }, _vm._l(_vm.options, function (option, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "option-spacer"
    }, [_vm._v("\n              " + _vm._s(option.value ? option.value : option) + "\n            ")])]);
  }), 0)]), _vm._m(0)]), !_vm.collapsed ? _c('div', {
    staticClass: "options-container"
  }, _vm._l(_vm.options, function (option, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.handleSelection(option);
        }
      }
    }, [_c('div', {
      staticClass: "option",
      class: _vm.selection && _vm.selection.id == option.id || !_vm.selection && option.correct && _vm.numOfAttempts >= 2 ? 'highlighted' : ''
    }, [_vm._v("\n          " + _vm._s(option.value ? option.value : option) + "\n        ")])]);
  }), 0) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow-down"
  })]);
}]

export { render, staticRenderFns }